import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { FileText } from 'lucide-react';
import SEO from '../components/SEO';
import { seoData } from '../data/translations';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <SEO 
        title={seoData.impressum.title}
        description={seoData.impressum.description}
      />
      <Navbar />
      <main>
        <section className="relative pt-40 pb-20">
          <div className="relative max-w-4xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-3 mb-6">
                <div className="h-px w-12 bg-[#D4AF37]" />
                <span className="text-black/50 text-sm font-medium uppercase tracking-[0.3em]">Legal</span>
                <div className="h-px w-12 bg-[#D4AF37]" />
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">Impressum</h1>
            </div>

            <div className="bg-white rounded-3xl border border-black/5 shadow-xl p-8 md:p-12">
              <div className="prose prose-lg max-w-none">
                
                {/* Section 1: Provider Information */}
                <div className="mb-10">
                  <div className="flex items-center gap-3 mb-4">
                    <FileText className="w-6 h-6 text-[#D4AF37]" />
                    <h2 className="text-2xl font-bold text-black m-0">Angaben gemäß § 5 DDG</h2>
                  </div>
                  <div className="pl-9 space-y-1 text-black/70">
                    <p className="font-semibold text-black text-lg">Yetkin Dienstleistungen GmbH</p>
                    <p>Reuchlinstr. 10</p>
                    <p>10553 Berlin</p>
                  </div>
                </div>

                {/* Section 2: Commercial Register */}
                <div className="mb-10">
                  <h3 className="text-xl font-semibold text-black mb-3">Handelsregister</h3>
                  <div className="space-y-1 text-black/70">
                    <p>Registergericht: Amtsgericht Berlin-Charlottenburg</p>
                    <p>Registernummer: HRB 247244 B</p>
                  </div>
                </div>

                {/* Section 3: Representation */}
                <div className="mb-10">
                  <h3 className="text-xl font-semibold text-black mb-3">Vertreten durch</h3>
                  <p className="text-black/70">Cagdas Yetkin (Geschäftsführer)</p>
                </div>

                {/* Section 4: Contact */}
                <div className="mb-10">
                  <h3 className="text-xl font-semibold text-black mb-3">Kontakt</h3>
                  <div className="space-y-1 text-black/70">
                    <p>Telefon: <a href="tel:+493033771813" className="text-[#D4AF37] hover:underline">030 33771813</a></p>
                    <p>E-Mail: <a href="mailto:info@yetkin-dienstleistungen.de" className="text-[#D4AF37] hover:underline">info@yetkin-dienstleistungen.de</a></p>
                  </div>
                </div>

                {/* Section 5: VAT ID */}
                <div className="mb-10">
                  <h3 className="text-xl font-semibold text-black mb-3">Umsatzsteuer-ID</h3>
                  <p className="text-black/70">
                    Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                    <span className="font-medium text-black">DE356814456</span>
                  </p>
                </div>

                {/* Section 6: Editorial Responsibility */}
                <div className="mb-10">
                  <h3 className="text-xl font-semibold text-black mb-3">Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV</h3>
                  <div className="space-y-1 text-black/70">
                    <p className="font-medium text-black">Jacqueline Yetkin</p>
                    <p>Reuchlinstr. 10</p>
                    <p>10553 Berlin</p>
                  </div>
                </div>

                {/* Section 7: EU Dispute Resolution */}
                <div className="mb-10">
                  <h3 className="text-xl font-semibold text-black mb-3">EU-Streitschlichtung</h3>
                  <p className="text-black/70">
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                    <a 
                      href="https://ec.europa.eu/consumers/odr/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#D4AF37] hover:underline break-all"
                    >
                      https://ec.europa.eu/consumers/odr/
                    </a>
                  </p>
                  <p className="text-black/70 mt-2">
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.
                  </p>
                </div>

                {/* Section 8: Consumer Dispute Resolution */}
                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-black mb-3">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h3>
                  <p className="text-black/70">
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>

              </div>
            </div>

            {/* Last Updated */}
            <p className="text-center text-black/40 text-sm mt-8">
              Stand: Januar 2026
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ImpressumPage;
